export const appTheme = {
  palette: {
    primary: {
      main: "#301D35",
      dark: "#00B0CC",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#DBDFE6",
      dark: "#B9BEC7",
      contrastText: "#2B3952",
    },
    danger: {
      main: "#EB0000",
      contrastText: "#FFFFFF",
    },
    action: {
      disabled: "#DBDFE6",
    },

    text: {
      primary: "#080425",
      secondary: "#00B0CC",
      tertiary: "#fff",
    },
  },
  typography: {
    fontFamily: "Inter",

    h1: {
      fontSize: 28,
      fontWeight: 600,
      letterSpacing: 0.28,
    },

    h2: {
      fontSize: 25,
      fontWeight: 600,
      letterSpacing: 0.25,
    },
    h3: {
      fontSize: 22,
      fontWeight: 600,
    },
    h4: {
      fontSize: 20,
      fontWeight: 600,
    },
    h5: {
      fontSize: 18,
      fontWeight: 600,
    },
    h6: {
      fontSize: 18,
      fontWeight: 700,
    },
    subtitle1: {
      fontSize: 12,
    },
    body1: {
      fontSize: 14,
      fontWeight: 400,
    },
    body2: {
      fontSize: 12,
      fontWeight: 400,
    },

    body3: {
      fontSize: 9,
      fontWeight: 400,
    },

    body4: {
      fontSize: 14,
      fontWeight: 700,
      color: "#080425",
    },
    body5: {
      fontSize: 12,
      fontWeight: 700,
      color: "#080425",
    },
    body6: {
      fontSize: 16,
      fontWeight: 800,
      color: "#080425",
    },
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          textTransform: "none",
        }),
      },
      variants: [
        {
          props: { variant: "outlined" },
          style: {
            backgroundColor: "transparent",
            color: "#301D35",
            border: `1px solid #301D35`,
            "&:hover": {
              color: "white",
              border: `1px solid #301D35`,
            },
          },
        },
        {
          props: { variant: "contained" },
          style: {
            backgroundColor: "#301D35",
            inlineBorder: `1px solid #301D35`,
            "&:hover": {
              backgroundColor: "#DEDAFB",
              border: `1px solid #301D35`,
              color: "#301D35",
            },
            "&:disabled": {
              backgroundColor: "#301D35",
              inlineBorder: `1px solid #301D35`,
              opacity: "0.6",
            },
          },
        },
        {
          props: { variant: "outlined", color: "secondary" },
          style: {
            backgroundColor: "white",
            inlineBorder: `1px solid #301D35`,
            "&:hover": {
              color: "black",
              backgroundColor: "#DEDAFB",
              inlineBorder: `1px solid #301D35`,
            },
            "&:disabled": {
              backgroundColor: "#301D35",
              inlineBorder: `1px solid #301D35`,
              opacity: "0.6",
            },
          },
        },

        {
          props: { variant: "filled", color: "primary" },
          style: {
            color: "#080425",
            backgroundColor: "#EFEDFD",
            border: `1px solid #080425`,

            "&:hover": {
              backgroundColor: "#DEDAFB",
            },
            "&:disabled": {
              opacity: "0.6",
            },
          },
        },

        {
          props: { variant: "filled", color: "tertiary" },
          style: {
            color: "#080425",
            backgroundColor: "#77E250",
            border: `1px solid #080425`,

            "&:hover": {
              backgroundColor: "#dedafb",
            },
            "&:disabled": {},
          },
        },

        {
          props: { variant: "filled", color: "error" },
          style: {
            color: "#fff",
            backgroundColor: "#E00",
            border: `1px solid #080425`,

            "&:hover": {
              color: "#080425",
              backgroundColor: "#dedafb",
            },
            "&:disabled": {
              opacity: "0.6",
            },
          },
        },
      ],
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
};
